/**
 * Krok PRF5 bod 2 — STUPNICE RIZIKA ZAPLAVOVEHO UZEMI NA JEDNOM MISTE.
 *
 * Zive 13. 10. 2026 (Petrovice 475, Q100 Petrovickeho potoka): dokument o
 * zaplavovem uzemi rekl, ZE v nem predmet lezi, ale NIJAK ho neohodnotil —
 * jediny stupen rizika na strane povodni patril privalovemu desti („mirne"),
 * takze kupujici cetl „Q100 = mirne". R.B. 13. 10.: Q100 je pro banku
 * a pojistovnu ZVYSENE riziko, ne mirne.
 *
 * Stupnice (zadani PRF5 bod 2):
 *   - mimo zaplavova uzemi                   -> `low`
 *   - Q100 (nebo Q500) mimo aktivni zonu     -> `elevated`
 *   - Q20, Q5 nebo aktivni zona              -> `high`
 *
 * TOHLE je to jedno misto, ktere stupnici zna. Ctou ho oba dokumenty reportu
 * (`report/v5/flood.ts` — semafor podrobne i klientske verze, `chapters.ts` —
 * dlazdice rizik) i karta rizik v adminu (`riskSummary` v `@reos/reports`).
 * Druha kopie teze stupnice by se po prvni zmene rozesla (CLAUDE.md §8
 * pravidlo 2).
 */
/**
 * Stupen rizika ze zaplavovych uzemi. Bez odpovedi je `unknown` — nikdy `low`:
 * „nevime" neni „nic tu neni" (tataz uvaha jako u pluvialniho svetla).
 *
 * ROZHODNUTI PRF5-1: Q500 je `elevated` stejne jako Q100. Zadani jmenuje tri
 * stupne a Q500 mezi „mimo zaplavova uzemi" nepatri — dokument o predmetu uz
 * tvrdi „lezi v zaplavovem uzemi" (`dd.reportV5.flood.decision.inZone`) a stupen
 * rizika mu nesmi odporovat.
 */
export function floodZoneRiskLevel(input) {
    if (input.inActiveZone)
        return 'high';
    if (!input.answered)
        return 'unknown';
    if (input.reach === 'q5' || input.reach === 'q20')
        return 'high';
    if (input.reach === 'q100' || input.reach === 'q500')
        return 'elevated';
    return 'low';
}
/** Klic slova stupnice v katalogu — jedno misto i pro slova, ne jen pro pravidlo. */
export function floodZoneRiskLevelKey(level) {
    return `dd.reportV5.flood.level.${level}`;
}
/**
 * `true` = zaplavove uzemi parcelu ZASAHUJE. Dva pravopisy teze pravdy:
 * `present` pridal krok B1d (vada 13), `inFloodZone` je ve faktech zapsanych
 * driv (zivy beh T1b). Od PRF5 je definice TADY, protoze ji vedle modelu
 * reportu cte i karta rizik v adminu (`riskSummary` v `@reos/reports`);
 * `site-facts.ts` ji jen re-exportuje, aby ctenari v kontextu nemenili import.
 */
export function inFloodZone(value) {
    return value['present'] === true || value['inFloodZone'] === true;
}
/*
 * TENHLE MODUL MUSI ZUSTAT BEZ ZAVISLOSTI. Cte ho prohlizec (karta rizik
 * v adminu pres podcestu `@reos/duediligence/flood-risk`), takze jediny
 * import `@reos/db` nebo `@reos/observability` by do balicku administrace
 * pritahl `node:async_hooks` a web-admin by se prestal sestavovat — tentyz
 * duvod, proc `@reos/reports` bere z barrelu kontextu jen TYPY.
 */
//# sourceMappingURL=flood-risk.js.map